import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as marketSpecialsRouteProps } from "@faire/web-api--source/routes/markets/event_type/all-specials";
import { props as marketsAllSpecialsMyMarketListRouteProps } from "@faire/web-api--source/routes/markets/event_type/all-specials/my-market-list";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
import { LazyPromotionsHub, LazyMyMarketList } from "@faire/retailer/features/FaireMarkets/PromotionsHub";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { MarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
var MarketPreshowRouterBase = function() {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsxs(Switch, {
            children: [
                MarketStore.get().showAllSpecials ? /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, marketSpecialsRouteProps), {
                    component: LazyPromotionsHub,
                    exact: true
                })) : null,
                MarketStore.get().showMarketList ? /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, marketsAllSpecialsMyMarketListRouteProps), {
                    component: LazyMyMarketList
                })) : null,
                /*#__PURE__*/ _jsx(Redirect, {
                    to: home()
                })
            ]
        })
    });
};
export var MarketPreshowRouter = observer(MarketPreshowRouterBase);
